/* Run function after window resize */
var afterResize=(function(){var t={};return function(callback,ms,uniqueId){if(!uniqueId){uniqueId="Don't call this twice without a uniqueId";}if(t[uniqueId]){clearTimeout(t[uniqueId]);}t[uniqueId]=setTimeout(callback,ms);};})();

window.theme = window.theme || {};

theme.cacheSelectors = function () {
  theme.cache = {
    // General
    $w: $(window),
    $body: $('body'),

    // Mobile Nav
    $mobileNavTrigger: $('#MobileNavTrigger'),
    $mobileNav: $('#MobileNav'),
    $mobileSublistTrigger: $('.mobile-nav__sublist-trigger'),

    // Equal height elements
    $productGridImages: $('.grid-link__image--product'),
    $featuredGridImages: $('.grid-link__image--collection'),

    // Product page
    $productImage: $('#ProductPhotoImg'),
    $productImageGallery: $('.gallery__item'),

    // Cart Page
    cartNoteAdd: '.cart__note-add',
    cartNote: '.cart__note',

    // Add to cart - Ajax
    $cartCount: $('.cart-count'),
    $addToCartBtn: $('form[action^="/cart/add"] :submit'),
    
    // Complete your Look
    $completeLookBtn: $('.complete-look-btn'),
    //offcart remove button
    $rmvOffsdToCartBtn: $('.offside-cart-remove-btn'),
    //Gift cart add to card button 2018
    $giftCardToCartBtn: $('.gift-card-recap-btn'),
    //Button digital gif card 2019
    $digiCardToCartBtn: $('#add_digicard'),
    //Sticky add to cart button
    $stickyAddToCartBtn: $('.sticky-add-to-cart-btn'),

    //Navigation
    $hasDropdownItem: $('.site-nav--has-dropdown')
  }
};

timber.cacheVariables = function () {
  timber.vars = {
    isTouch: timber.cache.$html.hasClass('supports-touch')
  }
};

theme.mobileNav = function () {
  theme.cache.$mobileNavTrigger.on('click', function() {
    theme.cache.$mobileNav.slideToggle(220);
  });

  theme.cache.$mobileSublistTrigger.on('click', function(evt) {
    var $el = $(this);

    // Enable commented out if statement to allow direct clicking on trigger link
    // if (!$el.hasClass('is-active')) {
      evt.preventDefault();
      $el.toggleClass('is-active').next('.mobile-nav__sublist').slideToggle(200);
    // }
  });
};

theme.productImageGallery = function() {

  if (!theme.cache.$productImageGallery.length) {
    return;
  };

  theme.cache.$productImageGallery.magnificPopup({
    type: 'image',
    mainClass: 'mfp-fade',
    closeOnBgClick: true,
    closeBtnInside: false,
    closeOnContentClick: true,
    tClose: 'Close (Esc)',
    removalDelay: 500,
    callbacks: {
      open: function(){
        $('html').css('overflow-y','hidden');
      },
      close: function(){
        $('html').css('overflow-y','');
      }
    },
    gallery: {
      enabled: true,
      navigateByImgClick: false,
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
      tPrev: 'Previous (Left arrow key)',
      tNext: 'Next (Right arrow key)'
    }
  });

  theme.cache.$productImage.bind('click', function() {
    var imageId = $(this).attr('data-image-id');
    theme.cache.$productImageGallery.filter('[data-image-id="' + imageId + '"]').trigger('click');
  });
};

theme.backButton = function () {
  var referrerDomain = urlDomain(document.referrer);
  var shopDomain = urlDomain(document.url);

  if (shopDomain === referrerDomain) {
    history.back();
    return false;
  }

  function urlDomain(url) {
    var    a      = document.createElement('a');
           a.href = url;
    return a.hostname;
  }
};

theme.cartPage = function () {
    
  
    theme.cache.$body.on('click', theme.cache.cartNoteAdd, function () {
      $(this).addClass('is-hidden');
      $(theme.cache.cartNote).addClass('is-active');
      ajaxifyShopify.sizeDrawer();
    });
  };
  
theme.addToCartBtnMessage = function () {
  const btn = document.getElementById('AddToCart');
  btn.classList.add('show-msg', 'no-disabled-style');
  btn.disabled = true;
  setTimeout(function(){
    btn.classList.remove('show-msg', 'no-disabled-style');
    btn.disabled = false;
  },4000);
};

theme.addToCartflip = function ($addToCartBtn) {

  // Get label of add to cart button
  var addToCartText = $addToCartBtn.attr('data-add-to-cart') || "Add to Cart";

  // Make a copy of the add to cart button should we flip it
  $addToCartBtn
    .clone(true)
    .prop('disabled', false)
    .removeClass('disabled')
    .addClass('btn--unflipped')
    .find('span')
    .text(addToCartText)
    .end()
    .hide()
    .insertAfter($addToCartBtn);

  $addToCartBtn
    .unbind('click')
    .removeClass('disabled')
    .find('span')
    .text("View cart")
    .end()
    .bind('click', function(e) {
      e.preventDefault();
      window.location.href = '/cart';
    })
    .prop('disabled', false)
    .addClass('btn--flipped')
    .after('<span class="continue-shopping"> <a class="btn btn-two" href="/collections/all">Continue shopping</a></span>');

  $('.continue-shopping a').bind('click', theme.backButton);

  // Unflip button if another variant is selected
  $('.single-option-selector, [name="quantity"]').bind('click', function() {
    $(this).closest('form').find('.btn--flipped, .continue-shopping, .note').remove();
    $(this).closest('form').find('.btn--unflipped').removeClass('.btn--unflipped').show();
  });
};

theme.enableAjax = function () {

  //OFFSIDE CART PLUS/MINUS BUTTON
  $('body').on('click', '.offside-btn-number', function(e) {
  	e.preventDefault();
    
    if($(this).data('qty') > 0) {
      var dataToPass = {'quantity': $(this).data('qty'), 'id': $(this).data('line-item-id')};

      $.ajax({
        url: '/cart/change.js',
        dataType: 'json',
        type: 'post',
        data: $.param(dataToPass),
        success: function(lineItem) {
          console.log('successfully removed!');
          $.getJSON('/cart.js', function(cart) {
            theme.cache.$cartCount.text(cart.item_count);
            $('.hidden-count').removeClass('hidden-count');
            theme.offsideCartUpdate(cart);
          });        
        },
        error: function(XMLHttpRequest, textStatus) {
          var data = eval('(' + XMLHttpRequest.responseText + ')');
          var response = data.description;
          console.log(response);
        }
     });
    }
  });
  
  //OFFSIDE CART REMOVE BUTTON
  $('body').on('click', '.offside-cart-remove-btn', function(e) {
  	e.preventDefault();
    var dataToPass = {'quantity': 0, 'id': $(this).data('line-item-id')};
    
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      type: 'post',
      data: $.param(dataToPass),
      success: function(lineItem) {
      	console.log('successfully removed!');
        $.getJSON('/cart.js', function(cart) {
          theme.cache.$cartCount.text(cart.item_count);
          $('.hidden-count').removeClass('hidden-count');
          theme.offsideCartUpdate(cart);
        });        
      },
      error: function(XMLHttpRequest, textStatus) {
        var data = eval('(' + XMLHttpRequest.responseText + ')');
        var response = data.description;
        console.log(response);
      }
    });
  });

  theme.cache.$addToCartBtn.bind('click', function(e) {
    e.preventDefault();
    $('.note.errors').remove();
    var $addToCartBtn = $(this),
        $addToCartForm = $(this).closest('form'),
        $addToCartBtnText = $(this).find('span');
    if ($addToCartForm.length) {
      $addToCartBtn
        .attr('data-add-to-cart', $addToCartBtnText.text())
      	//the following two lines if uncommented display disabled add button after product ajax add
        //.prop('disabled', true) 
        //.addClass('disabled')
        .addClass('btn--loading');
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function(lineItem) {
          
          	//theme.quickCartPopUp(lineItem);
          
          
          var $lineItemId = lineItem.variant_id;
          
          $.getJSON('/cart.js', function(cart) {
            theme.cache.$cartCount.text(cart.item_count);
            $('.hidden-count').removeClass('hidden-count');
            
            theme.offsideCartUpdate(cart);
            theme.offsideCartOpen();   
          });
          $addToCartBtn.removeClass('btn--loading');
          //theme.addToCartflip($addToCartBtn); //uncomment to flip from add btn to view cart btn
          theme.addToCartBtnMessage();
        },
        error: function(XMLHttpRequest, textStatus) {
          var data = eval('(' + XMLHttpRequest.responseText + ')');
          var response = data.description;
          var status = XMLHttpRequest.status;
          $addToCartBtn.removeClass('btn--loading');
          
          if (status === 422 && $('#productSelect option').length === 1) {
            $addToCartBtnText.text("Not Available");
          }
          else {
            $addToCartBtn.prop('disabled', false).removeClass('disabled');
            /*$addToCartBtnText.text($addToCartBtn.attr('data-add-to-cart'));*/
          }
          $('.lp-product-form-message').after('<p class="note errors">' + response + '</p>');
        }
      });
    }
  });
  
  theme.cache.$stickyAddToCartBtn.bind('click', function(e) {
    e.preventDefault();
  	var id = $(this).attr('id').replace('sticky-add-to-cart-btn-', '');
    var selectedVariant = $('#sticky-add-to-cart-'+id).val();
    
    var dataToPass = {'quantity': 1, 'id': selectedVariant};
      
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: $.param(dataToPass),
      success: function(lineItem) {
      	//console.log('successfully added!');
        
          //theme.quickCartPopUp(lineItem);
        

        $.getJSON('/cart.js', function(cart) {
          theme.cache.$cartCount.text(cart.item_count);
          $('.hidden-count').removeClass('hidden-count');
          
          theme.offsideCartUpdate(cart);
          theme.offsideCartOpen();
        });
      },
      error: function(XMLHttpRequest, textStatus) {
        //var data = eval('(' + XMLHttpRequest.responseText + ')');
       // var response = data.description;
        //$('#complete-look-error-'+id).html(response);
      }
    });
  });
  
  //COLLECTION HOVER QUICK ADD TO CART
  $('body').on('click', '.quick-coll-add-btn', function(e) {
    e.preventDefault();
  	var id = $(this).data('variant-id');
    
    var dataToPass = {'quantity': 1, 'id': id};
      
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: $.param(dataToPass),
      success: function(lineItem) {
      	//console.log('successfully added!');
        
          //theme.quickCartPopUp(lineItem);
        

        $.getJSON('/cart.js', function(cart) {
          theme.cache.$cartCount.text(cart.item_count);
          $('.hidden-count').removeClass('hidden-count');
          
          theme.offsideCartUpdate(cart);
          theme.offsideCartOpen();
        });
     
        
      },
      error: function(XMLHttpRequest, textStatus) {
        //var data = eval('(' + XMLHttpRequest.responseText + ')');
       // var response = data.description;
        //$('#complete-look-error-'+id).html(response);
      }
     });
  });
  
  //OFFSIDE CART COMPLETE ADD TO CART
  $(document).on('click', '.offcanvas-cart-complete-add-btn', function(e) {
    e.preventDefault();
  	var id = $(this).data('variant-id');
    
    var dataToPass = {
      'quantity': 1, 
      'id': id/*,
      'properties': {
        '_offcanvasComplete': true
      }*/
    };
      
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: $.param(dataToPass),
      success: function(lineItem) {
        $.getJSON('/cart.js', function(cart) {
          theme.cache.$cartCount.text(cart.item_count);
          $('.hidden-count').removeClass('hidden-count');
          
          theme.offsideCartUpdate(cart);
          theme.offsideCartOpen();
        });
     
        
      },
      error: function(XMLHttpRequest, textStatus) {
      }
     });
  });
  
  theme.cache.$completeLookBtn.bind('click', function(e) {
    e.preventDefault();
  	var id = $(this).attr('id').replace('complete-look-btn-', '');
    var selectedVariant = $('#complete-look-'+id).val();
    
    var dataToPass = {'quantity': 1, 'id': selectedVariant};
      
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: $.param(dataToPass),
      success: function(lineItem) {
      	console.log('successfully added!');
        
          //theme.quickCartPopUp(lineItem);
        

        $.getJSON('/cart.js', function(cart) {
          theme.cache.$cartCount.text(cart.item_count);
          $('.hidden-count').removeClass('hidden-count');
          
          theme.offsideCartUpdate(cart);
          theme.offsideCartOpen();
        });
        
        $('#complete-look-error-'+id).html('');

      },

      error: function(XMLHttpRequest, textStatus) {
        var data = eval('(' + XMLHttpRequest.responseText + ')');
        var response = data.description;
        $('#complete-look-error-'+id).html(response);
      }
     });
  });
  
  theme.cache.$giftCardToCartBtn.bind('click', function(e) {
    e.preventDefault();
  	var selectedVariant = $('#gift-card-recap').data('variant-id');
    //var date = $('#gift-card-recap').data('date');
    //var yourName = $('#gift-card-recap').data('your-name');
    //var recipientName = $('#gift-card-recap').data('recipient-name');
    //var recipientEmail = $('#gift-card-recap').data('recipient-email');
    //var recipientMessage = $('#gift-card-recap').data('message');
    
   
    var dataToPass = {
      'quantity': 1, 
      'id': selectedVariant,
    };
    
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: $.param(dataToPass),
      //properties: $.param(propertiesToPass),
      success: function(lineItem) {
      	console.log('gift card successfully added!');

        $.getJSON('/cart.js', function(cart) {
          theme.cache.$cartCount.text(cart.item_count);
          $('.hidden-count').removeClass('hidden-count');
          
          theme.offsideCartUpdate(cart);
          theme.offsideCartOpen();
        });
        
        //$('#complete-look-error-'+id).html('');
        
      },
      error: function(XMLHttpRequest, textStatus) {
        //var data = eval('(' + XMLHttpRequest.responseText + ')');
        //var response = data.description;
        //$('#complete-look-error-'+id).html(response);
      }
     });
    
  });
  
  // Add to cart digital gift card 2019
  theme.cache.$digiCardToCartBtn.bind('click', function(e) {
    e.preventDefault();
    
    
  	var selectedVariant = $(this).attr('data-variant-id');
    console.log(selectedVariant);
    $("#digital_gift_card_2019 .active_card").removeClass("active_card");
    $(this).attr("data-variant-id", "");
    
    if( selectedVariant ){
    var dataToPass = {
      'quantity': 1, 
      'id': selectedVariant,
    };
    
    console.log(dataToPass);
    
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: $.param(dataToPass),
      //properties: $.param(propertiesToPass),
      success: function(lineItem) {
      	

        $.getJSON('/cart.js', function(cart) {
          theme.cache.$cartCount.text(cart.item_count);
          $('.hidden-count').removeClass('hidden-count');
          
          theme.offsideCartUpdate(cart);
          theme.offsideCartOpen();
        });
        
     
      },
      error: function(XMLHttpRequest, textStatus) {
        
      }
     });
    }
    
  });

};

var closeOverlay = {
    trigger:function(element){
        switch(element){
            case 'cart':
                this.closemenu();
                this.closesearch();
                break;
            case 'search':
                this.closemenu();
                this.closecart();
                break;
            case 'menu':
                this.closecart();
                this.closesearch();
                break;
        }
    },
    closemenu: function(){
        if($(".hamburger-btn").hasClass("open")){
            $(".hamburger-btn").removeClass("open");
            $(".middle").addClass("reverse-mobile-menu-anim-open");
            $('body').removeClass('menuopen');
        }
    },
    closecart: function(){
        if($("form.cart").hasClass('open')){
            $("form.cart").removeClass("open");
            $('body').removeClass('menuopen');
        }
    },
    closesearch: function(){
        if($("form.search > .dropdown").hasClass("open")){
          $("form.search > .dropdown").removeClass("open");
          $('body').removeClass('menuopen');
        }
    }
}

//OFFISE CART UPDATE
theme.offsideCartUpdate = function(cart) {
  // Handlebars.js cart layout
  var items = [],
      item = {},
      data = {},
      source = $("#offside-cart-template").html(),
      template = Handlebars.compile(source);
  
  $.each(cart.items, function(index, cartItem) {
  	if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_90x120_crop_center$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
             delete cartItem.properties[key];
           }
        });
      }
    
      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.id,
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        gift_card: cartItem.gift_card,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price,window.Currency.moneyFormats[Shopify.currency.active].money_format), 
        discountedPrice: Shopify.formatMoney((cartItem.price - (cartItem.total_discount/cartItem.quantity)), window.Currency.moneyFormats[Shopify.currency.active].money_format),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.price === (cartItem.price - cartItem.total_discount) ? false : true,
        vendor: cartItem.vendor
      };

    	console.log(item);
    
      items.push(item);
  });
  
  data = {
    items: items,
    item_count: cart.item_count,
    note: cart.note,
    totalPrice: Shopify.formatMoney(cart.total_price,window.Currency.moneyFormats[Shopify.currency.active].money_format),
    totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount,window.Currency.moneyFormats[Shopify.currency.active].money_format)),
    checkout: 'checkout',
    empty: 'Your cart is empty.Free shipping over $120 (exc. Norway).\nEasy return worldwide on all orders. <a href="/pages/customer-care" style="text-decoration: underline; font-weight: 500">Learn more</a>',
    size: 'Size',
    subtotal: 'Subtotal'
  };

  var ourGeneratedHtml = template(data);
  $('#offside-cart-body-container').html(ourGeneratedHtml);

  $('#offside-cart .offside-cart-header div').load('#offside-cart .offside-cart-header div');

  if (cart.item_count === 0) {
      $('#offside-cart .offside-cart-header').addClass('header-empty');
  } else {
      $('#offside-cart .offside-cart-header').removeClass('header-empty');
  }
};

$('.pg_cart .input-number').change(function() {
    $('.btn-update-cart').trigger('click');
});


//open close cart Alpenite
/*$('.cart-btn').on('click', function (e){*/
$('.mobile-quick-access-container li.hide-on-cart.rb-cart, #quick-btn-container .cart-btn').on('click', function (e){
    e.preventDefault();
    closeOverlay.trigger('cart');
    $('form.cart').toggleClass('open');
  if(window.innerWidth < 1200) {
    if ($("form.cart").hasClass("open")) {
        $('body').addClass('menuopen cartopen');
    } else {
        $('body').removeClass('menuopen cartopen');
    }
  }
});
$('#offside-cart-close-btn').on('click', function (){
    $('form.cart').removeClass('open');
    $('body').removeClass('menuopen');
});

//OFFSIDE CART OPEN
theme.offsideCartOpen = function () {
    $('form.cart').addClass('open');
  
  	var evt = new CustomEvent('cartIsOpen');
    window.dispatchEvent(evt);
}

theme.quickCartPopUp = function(item) {
  //if($(window).width() > 991){
    $('#quickAddPopUp-img').attr('src', item.image);
    $('#quickAddPopUp-img').attr('alt', item.title);
    $('#quickAddPopUp-title').text(item.title);
  	$('#quickAddPopUp-price').html('<span class="money">' + Shopify.formatMoney(item.price,window.Currency.moneyFormats[Shopify.currency.active].money_format) + '</span>');
  
    /*if(Currency.moneyFormats) {
      mlvedaload();
    }*/
  	
    $('#quickAddPopUp-img').load(function() {
        $("#quickAddPopUp").show().delay(4000).fadeOut();
    }).each(function() {
      if(this.complete) $(this).load();
    });
  //}
};

$('.shopify-currency-form select').on('change', function() {
  $(this)
    .parents('form')
    .submit();
});


$('form.search > .dropdown').on('show.bs.dropdown', function () {
    $('body').addClass('menuopen');
    closeOverlay.trigger('search');
});
$('form.search > .dropdown').on('hide.bs.dropdown', function () {
    $('body').removeClass('menuopen');
});

theme.predictiveSearch = function() {
    searchAutocomplete.init();
};

var searchAutocomplete = {
  init: function(){

    var currentAjaxRequest = null;

    var searchForms = $('form.search').each(function() {

      var input = $(this).find('input[name="q"]');
      var boxSearch = $(this).find('.box_search');

      // Adding a list for showing search results.
      $('<div class="search__results-wrapper"><div class="search__results-products"><ul class="search__results"></ul></div><div class="search__results-collections"><ul class="search__results"></ul></div></div>').appendTo(boxSearch);
      // Listening to keyup and change on the text field within these search forms.
      input.attr('autocomplete', 'off').bind('keyup change', function() {

        if(input.val() == '') {
          $('.search__results').hide();
          $('.search__results').empty();
          boxSearch.find('.no-results').remove();
            $('form.cart').removeClass('open');
        }

        var term = $(this).val();

        var form = $(this).closest('form');

        var resultsListProducts = form.find('.search__results-products .search__results');
        var resultsListCollections = form.find('.search__results-collections .search__results');

        if (term.length >= 3) {

          if (currentAjaxRequest != null) currentAjaxRequest.abort();          
          
          jQuery.getJSON("/search/suggest.json", {
            "q": term,
            "resources": {
              "type": "product,collection",
              "limit": 5,
              "options": {
                "unavailable_products": "last",
                "fields": "title,product_type,variants.title"
              }
            }
          }).done(function(data) {
            $('.search__results').empty();
            boxSearch.find('.no-results').remove();
            var productSuggestions = data.resources.results.products;
            var collectionSuggestions = data.resources.results.collections;
            if (productSuggestions.length == 0 && collectionSuggestions.length == 0) {
              $('.search__results').hide();
              
              var noResults = $('<div class="section-header section-header--large no-results"></div>');
              noResults.append('<h1 class="section-header__title h2">' + "No results were found for \"[term]\"".replace("[term]", term) + '</h1>');
              boxSearch.prepend(noResults);              
            } else{
              if (productSuggestions.length > 0) {  
                $('.search__results-products').fadeIn(200);             
                resultsListProducts.append("<h4>" + "Products" + "</h4>");
                $.each(productSuggestions, function(index, item) {
                  var link = $('<a></a>').attr('href', item.url);
                  if(item.available == true) {
                    var itemPrice = Shopify.formatMoney(item.price,window.Currency.moneyFormats[Shopify.currency.active].money_format);
                  } else {
                    var itemPrice = "Not Available";
                  }
                  link.append('<div class="thumbnail"><img class="lazyload" src="' + item.image + '" /></div>');
                  link.append('<div class="title">' + item.title + '<span class="item-pricing">'+ itemPrice +'</span></div>');
                  link.wrap('<li class="item-result result--products"></li>');
                  resultsListProducts.append(link.parent());
                });
                $('.search__results').fadeIn(200);
              } else {
                $('.search__results-products').hide();
              }
              if (collectionSuggestions.length > 0) {
                $('.search__results-collections').fadeIn(200);
                resultsListCollections.append("<h4>" + "Collections" + "</h4>");
                $.each(collectionSuggestions, function(index, item) {
                  var link = $('<a></a>').attr('href', item.url);
                  link.append('<div class="title">' + item.title);
                  link.wrap('<li class="item-result result--collections"></li>');
                  resultsListCollections.append(link.parent());
                });
                $('.search__results').fadeIn(200);
              } else {
                $('.search__results-collections').hide();
              }
            }
          });
        }
      });
    });

    // Clicking outside makes the results disappear.
    $(document).on('click', function(e){
      var container = $('[data-autocomplete-true]');
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('[data-autocomplete-true]').find('.search__results-wrapper').hide();
      }
    });

    $('[data-autocomplete-true] input').on('focus', function(){
      $('.search__results-wrapper').hide();
      $(this).parents('[data-autocomplete-true]').find('.search__results-wrapper').show();
    });
  },
  unload: function() {
    $('body').off('focus', '[data-autocomplete-true] input');
  }
}


/*theme.storesData = {
    domain: (typeof storesDataDomain != 'undefined') ? storesDataDomain : '',
    init: function(){
        this.getData();
    },

    getData: function(callaback){

        var stores = JSON.parse(localStorage.getItem('lp_stores'));
            expire = localStorage.getItem('lp_stores_expire');

        if(this.checkExpired(expire) || stores === null){

            $.ajax({
                url: this.domain + '/pages/stores?view=stores',
                method: 'GET',
                success: function (data) {

                    var setDate = new Date();
                    setDate.setHours(0,0,0,0);
                    setDate.setTime(setDate.getTime() + 15 * 86400000 );


                    localStorage.setItem('lp_stores' , data);
                    localStorage.setItem('lp_stores_expire',setDate);


                    // Callback in case we need the data we didn't had before
                    if(callaback){
                        switch (callaback) {
                            case 'popup':
                                theme.redirectPopup.showModal();
                                break;

                            case 'footerSelect':
                                theme.storesFooterMenu.show();
                                break;

                            case 'countrySelect':
                                theme.countrySelect.init();
                                break;
                        }

                    }

                },
                error: function(data) {
                    console.warn(data)
                }
            });

        }
    },

    checkExpired: function(expire){

        var ret = false;

        if(expire !== null){

            var a = Date.parse(expire),
                b = new Date().setHours(0,0,0,0),
                diff = a-b,
                days = Math.ceil( diff / (1000 * 3600 * 24));


                if(days<=0) ret = true;
        }
        return ret;
    }
}*/


isYoutubeAPILoaded = false;

function loadYoutubeAPI() {
    if (isYoutubeAPILoaded) {
        return;
    } else {
        // Load Youtube API script
        var tag = document.createElement('script');
        tag.src = "//www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
}

function onYouTubeIframeAPIReady() {
    isYoutubeAPILoaded = true;
    $('body').trigger('youtubeAPIReady');
}

theme.heroSlider = {
    selector: '.lp-hero__slider',
    mainClass: 'lp-hero__slider',
    breakpoint: 768,
    init: function(){
        var $sliders = $(this.selector);
        var self = this;


        $sliders.each(function(){
            var $slider = $(this);
            // First init check
            self.checkSlideVideo($slider);
            $slider.on('slide.bs.carousel', function () {
                // On slide check
                self.checkSlideVideo($slider);
            });
        });
    },
    checkSlideVideo: function($slider){
        $slide = $slider.find(`.item.active ${this.selector}__video-wrap`),
        self = this;
        if($slide.length == 1){

            var videoId = $slide.attr('video-id'),
                videoMobileId = $slide.attr('video-mobile-id'),
                videoType = $slide.attr('video-type');

                // Override mobile video id based on window width
                if($(window).outerWidth() <= this.breakpoint) videoId = videoMobileId;

                if(videoType == 'youtube'){
                    if(!window.isYoutubeAPILoaded){

                        window.loadYoutubeAPI();

                        $('body').on('youtubeAPIReady', function(){
                            self.playSlideVideo($slide,videoId,videoType);
                        });
                    } else {
                        self.playSlideVideo($slide,videoId,videoType);
                    }
                } else if(videoType == 'vimeo') {
                    self.playSlideVideo($slide,videoId,videoType);
                }
        }
    },
    playSlideVideo: function($slide,videoId,type){
        $slide.html(`<div id="${$slide.data('block-id')}" class="${this.mainClass}__video"></div>`);
        if(type == 'youtube'){
            var video = new YT.Player( $slide.data('block-id'), {
                height: '100%',
                width: '100%',
                videoId: videoId,
                playerVars: {
                    cc_load_policy: 0,
                    iv_load_policy: 3,
                    modestbranding: 1,
                    playsinline: 1,
                    autohide: 0,
                    controls: 0,
                    branding: 0,
                    showinfo: 0,
                    rel: 0,
                    fs: 0,
                    wmode: 'opaque'
                },
                events: {
                    'onReady': function(e){
                        e.target.mute();
                        e.target.seekTo(0);
                        e.target.playVideo();
                    },
                    'onStateChange': function (event){
                        if (event.data == 0) {
                            event.target.playVideo();
                        }
                    }
                }
            });
        } else if(type == 'vimeo'){
            var video = new Vimeo.Player($slide.data('block-id'), {
                id: videoId,
                muted: true,
                autoplay: true,
                loop: true,
                title: false,
                controls: false
            });
        }
    }
}

theme.linkAll = {

    init: function(){
        $('.linkFrom').each(function() {
            var elemToLink = $(this).parents('.linkTo');
            var pageLink = $(this).attr('href');
            var linkTarget = (typeof $(this).attr('target')!=='undefined') ?  $(this).attr('target') : '' ;
            var nobarba = $(this).hasClass('no-barba');
            if(pageLink !== undefined && pageLink!=='javascript:;') {
            elemToLink.addClass('pointer').click({myLink:pageLink, myTarget:linkTarget, nobarba:nobarba},function(e){
                e.preventDefault();
                if(e.data.myTarget==='_blank'){
                window.open(e.data.myLink);
                } else {
                if(typeof barbaJs !=='undefined' && !e.data.nobarba){
                    Barba.Pjax.goTo(e.data.myLink);
                } else {
                    location.href = e.data.myLink;
                }
                }
            });
            }
        });
    },

    /**
     * ELEMENTI PARZIALMENTE LINKABILI (aree diversificate all'interno dello stesso contenitore)
     */
    initParts: function(){
        var elems = $('.linkFromPart');
        var elemsLg = elems.length;
        if(elemsLg>0){
            var i=0;
            for (i; i<=elemsLg-1; i++) {
            var el = $(elems[i]);
            var pageLink = el.attr('href');
            if(pageLink !== undefined) {
                var blockWrap = el.parents('.linkWrap');
                var elemsToLink = $('.linkToPart',blockWrap);
                var nobarba = $(this).hasClass('no-barba');
                elemsToLink.addClass('pointer').click({pageLink:pageLink,nobarba:nobarba},function(e){
                if(typeof barbaJs !=='undefined' && !e.data.nobarba){
                    Barba.Pjax.goTo(e.data.pageLink);
                } else {
                    location.href = e.data.pageLink;
                }
                });
            }
            }
        }
    }
}


// Swiper slider-review
theme.hpReview = {
  selector: '.lp-review',
  reviewSlider: function () {
    let swiper = new Swiper('.lp-review__featured .swiper-container', {
      slidesPerView: 1,
      spaceBetween: 10,
      freeModeSticky: true,
      mousewheel: false,
      keyboard: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        // when window width is >= 320px
        768: {
            slidesPerView: 2,
          	slidesPerGroup: 2
        }
    }
    });
  }
}

// Slider home-page
theme.hpFeaturedContent = {
  selector: '.lp-feat',
  containerAdjust: function () {
    let windowsWidth = $(window).width(),
        $container = $(`${this.selector}__featured-inner`);
        if  ($container.length == 0)
        return false;
        let maxWidth = windowsWidth-$container.offset().left;
        if (windowsWidth >= 1500 ) {
          $container.css('maxWidth', `${maxWidth}px`);
        } else {
          $container.css('maxWidth', '100%');
        }
        
  },
  sliderProduct: function () {
    this.containerAdjust();
    let obj = this;
    $(window).on('resize', function (){
      obj.containerAdjust();
    });
      let swiper = new Swiper('.lp-feat__featured-inner .swiper-container', {
        spaceBetween: 15,
        slidesPerView: 'auto',
        allowTouchMove: true,
        freeModeMomentumBounce: false,
        freeMode: true,
        freeModeSticky: true,
        mousewheel: false,
        keyboard: true,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
          dragSize: 250,
        }
      });
  }
}

//IOS
function iOSBodyClass(){
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (iOS) {
        $('body').addClass('is-iOS');
    } else {

    }
}
iOSBodyClass();

theme.init = function () {
    theme.linkAll.init();
    theme.cacheSelectors();
    timber.cacheVariables();
    theme.cartPage();
    /*theme.countrySelect.init();*/
    theme.heroSlider.init();
    theme.hpReview.reviewSlider();
    theme.hpFeaturedContent.sliderProduct();
    theme.hpFeaturedContent.containerAdjust();
    
    
      theme.predictiveSearch();
    
  
    
      theme.enableAjax();
    
};

// Initialize theme's JS on docready
$(theme.init)



